import { Player, PlayerOrNone } from '../../jscaip/Player';
import { TableUtils } from '../../jscaip/TableUtils';
import { GameStateWithTable } from '../../jscaip/state/GameStateWithTable';
export class DiaballikPiece {
    owner;
    holdsBall;
    static NONE = new DiaballikPiece(PlayerOrNone.NONE, false);
    static ZERO = new DiaballikPiece(Player.ZERO, false);
    static ZERO_WITH_BALL = new DiaballikPiece(Player.ZERO, true);
    static ONE = new DiaballikPiece(Player.ONE, false);
    static ONE_WITH_BALL = new DiaballikPiece(Player.ONE, true);
    constructor(owner, holdsBall) {
        this.owner = owner;
        this.holdsBall = holdsBall;
    }
    equals(other) {
        return this === other;
    }
}
export class DiaballikState extends GameStateWithTable {
    equals(other) {
        return TableUtils.equals(this.board, other.board);
    }
    isEmptyAt(coord) {
        const optional = this.getOptionalPieceAt(coord);
        if (optional.isPresent()) {
            return optional.get().owner.isNone();
        }
        else {
            return false;
        }
    }
    coordIsOwnedBy(coord, player) {
        const optional = this.getOptionalPieceAt(coord);
        if (optional.isPresent()) {
            return optional.get().owner.equals(player);
        }
        else {
            return false;
        }
    }
    coordIsNotOwnedBy(coord, player) {
        const optional = this.getOptionalPieceAt(coord);
        if (optional.isPresent()) {
            return optional.get().owner.equals(player) === false;
        }
        else {
            return false;
        }
    }
}
